type GetMaskedDisplayNameInput = {
  displayName?: string | null
}

/**
 * Returns a privacy-safe display name in the form "First N.".
 */
export const getMaskedDisplayName = ({
  displayName,
}: GetMaskedDisplayNameInput): string => {
  const trimmedDisplayName = displayName?.trim() ?? ''
  if (trimmedDisplayName.length === 0) return ''
  const isEmailLike = /^\S+@\S+\.\S+$/.test(trimmedDisplayName)
  if (isEmailLike) return ''

  const nameParts = trimmedDisplayName.split(/\s+/).filter(Boolean)
  if (nameParts.length <= 1) return nameParts[0] ?? ''

  const firstName = nameParts[0]
  const lastNameInitial = nameParts[nameParts.length - 1]?.[0]?.toUpperCase()
  if (!lastNameInitial) return firstName

  return `${firstName} ${lastNameInitial}.`
}
